import React from 'react';
import { Helmet } from 'react-helmet-async';
import AdminSideBar from './../../Containers/AdminSideBar';
import DirectoryContaier from './../../Containers/DirectoryContaier';
import { useTranslation } from 'react-i18next';


function Directory() {
    const { t } = useTranslation();
    return ( 
        <>
            <div className='ContentsWrapper ContentsWrapper2' >
                <Helmet>
                        <meta charSet="utf-8" />
                        <title>
                            {t("st:head.menu")} | {t("head.appTitle")}
                        </title>
                </Helmet>
                <AdminSideBar />
                <DirectoryContaier />
            </div>
        </>
     );
}

export default Directory;